const NextSteps = () => {
  const steps = [
    {
      title: 'Get a more accurate estimate for your home',
      description: `A real estate agent will be able to provide you with the most accurate estimate for your home.`,
      link: 'https://offers.bankrate.com/real-estate/agent?question-set=selling-home-valuation',
      linkText: 'Speak to an agent'
    },
    {
      title: 'Use your home equity',
      description: `A home equity loan lets you borrow against your home's value to pay for renovations, etc.`,
      link: 'https://bankrate.com/home-equity/home-equity-loan-rates/',
      linkText: 'Compare home equity rates'
    },
    {
      title: 'Refinance your mortgage',
      description: `Refinancing your mortgage can help you lower your monthly payment or pay off your home faster.`,
      link: 'https://bankrate.com/mortgages/refinance-rates/',
      linkText: 'Compare refinance rates'
    }
  ]

  return (
    <section className="section-wrapper bg-gray-light px-4 py-10 mb-10">
      <div className="wrapper-narrow">
        <p
          className="subheading text-blue
        uppercase text-center"
        >
          Next steps
        </p>
        <div className="display-grid grid-cols-1 md:grid-cols-3 gap-6 h-full">
          {steps.map((step, index) => (
            <div
              key={index}
              className="p-6 bg-white box-shadow-1 rounded display-flex justify-content-space-between flex-direction-column"
            >
              <div>
                <h4>{step.title}</h4>
                <p className="text-slate">{step.description}</p>
              </div>
              <a href={step.link} className="Button Button--primary w-full">
                {step.linkText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default NextSteps
